<template>
  <b-nav-item-dropdown right class="language-switcher">
    <template #button-content> {{ currentFlag }} {{ currentLabel }} </template>
    <b-dropdown-item
      v-for="lang in languages"
      :key="lang.code"
      :active="$i18n.locale === lang.code"
      @click="switchLanguage(lang.code)"
    >
      {{ lang.flag }} {{ lang.label }}
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { Validator } from "vee-validate";
import { ValidatorDictionary } from "@/i18n";

export default {
  name: "LanguageSwitcher",
  props: {
    portalLanguages: {
      type: Object,
      default: null,
    },
  },
  computed: {
    languages() {
      const allLanguages = [
        { code: "pt", flag: "🇧🇷", label: "PT" },
        { code: "en", flag: "🇺🇸", label: "EN" },
        { code: "es", flag: "🇪🇸", label: "ES" },
        { code: "de", flag: "🇩🇪", label: "DE" },
        { code: "zh", flag: "🇨🇳", label: "中文" },
        { code: "id", flag: "🇮🇩", label: "ID" },
      ];
      if (!this.portalLanguages) return allLanguages;
      return allLanguages.filter(
        (l) =>
          this.portalLanguages[l.code] && this.portalLanguages[l.code].enabled
      );
    },
    currentLabel() {
      const lang = this.languages.find((l) => l.code === this.$i18n.locale);
      return lang ? lang.label : "PT";
    },
    currentFlag() {
      const lang = this.languages.find((l) => l.code === this.$i18n.locale);
      return lang ? lang.flag : "🇧🇷";
    },
  },
  methods: {
    switchLanguage(code) {
      this.$i18n.locale = code;
      localStorage.setItem("preferred-locale", code);
      if (ValidatorDictionary[code]) {
        Validator.localize(code);
      }
    },
  },
};
</script>

<style scoped>
.language-switcher ::v-deep .dropdown-menu {
  //min-width: auto;
  overflow: hidden;
}

.language-switcher ::v-deep .dropdown-item {
  padding: 0.25rem 1rem;
}
</style>
